(function($) {
  $(function() {
    // if judgeme widget is clicked, expand the product reviews section
    $('.jdgm-preview-badge').click(function() {
      if($('.product-reviews .accordion').hasClass('active')) return;
      window.shopUtils.toggleSection(document.querySelector('.product-reviews .accordion'));
    });

    // Toggle Windows/Mac Products
    $(".show-mac").click(function() {
      $("#windows-options").addClass("hide");
      $("#mac-options").removeClass("hide");
      $("#windows-options-2").addClass("hide");
      $("#mac-options-2").removeClass("hide");
      $(".show-mac").addClass("selected");
      $(".show-windows").removeClass("selected");
    });
    $(".show-windows").click(function() {
      $("#windows-options").removeClass("hide");
      $("#mac-options").addClass("hide");
      $("#windows-options-2").removeClass("hide");
      $("#mac-options-2").addClass("hide");
      $(".show-windows").addClass("selected");
      $(".show-mac").removeClass("selected");
    });
    
    // Product Specs Hover highlighting
    $('[data-hover]').hover(function() {
      var myClass = findMyClass(this);
      $('[data-hover]:not(.' + myClass + ')').addClass('mute');
    }, function() {
      var myClass = findMyClass(this);
      $('[data-hover]:not(.' + myClass + ')').removeClass('mute');
    });

    function findMyClass(el) {
       return el.classList.value.split(" ").filter(function(cl){return !!cl && cl.indexOf('option')===0;})[0];
    };
  });
})(jQuery);